export default __webpack_public_path__ + "static/bepart-a55d9763cbabf7c62a3bc92816c1c3fd.png";